<div class="d-flex align-items-center" [style.flexDirection]="labelReverse ? 'row-reverse' : 'row'">
  <label
    [for]="'form-switch-' + id"
    class="m-0"
    [class.text-black]="!!ctrl.value"
    [class.text-bold]="!!ctrl.value"
    [class.mr-2]="!labelReverse"
    >
    <ng-content></ng-content>
    {{ label }}</label
  >
  <div class="custom-control custom-switch">
    <input type="checkbox" class="custom-control-input" [formControl]="ctrl" [id]="'form-switch-' + id" />
    <label class="custom-control-label" [for]="'form-switch-' + id"></label>
  </div>
</div>
